/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Successful response
 * @export
 * @interface GetClientLicense200Response
 */
export interface GetClientLicense200Response {
    /**
     * Reported employee count for this client.
     */
    employeeCount?: number;
    /**
     * Current subscription state: `active` (paid and running), `trialing` (in trial period), or `no_subscription` (no active subscription).
     */
    subscriptionStatus?: string;
    /**
     * Number of remaining user seats available under the current plan.
     */
    freeSeats?: number;
}

/**
 * Check if a given object implements the GetClientLicense200Response interface.
 */
export function instanceOfGetClientLicense200Response(value: object): value is GetClientLicense200Response {
    return true;
}

export function GetClientLicense200ResponseFromJSON(json: any): GetClientLicense200Response {
    return GetClientLicense200ResponseFromJSONTyped(json, false);
}

export function GetClientLicense200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetClientLicense200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'employeeCount': json['employeeCount'] == null ? undefined : json['employeeCount'],
        'subscriptionStatus': json['subscriptionStatus'] == null ? undefined : json['subscriptionStatus'],
        'freeSeats': json['freeSeats'] == null ? undefined : json['freeSeats'],
    };
}

export function GetClientLicense200ResponseToJSON(json: any): GetClientLicense200Response {
    return GetClientLicense200ResponseToJSONTyped(json, false);
}

export function GetClientLicense200ResponseToJSONTyped(value?: GetClientLicense200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employeeCount': value['employeeCount'],
        'subscriptionStatus': value['subscriptionStatus'],
        'freeSeats': value['freeSeats'],
    };
}

